// Detects iOS (iPhone/iPad/iPod), including iPadOS 13+ which reports as Mac.
// iOS Safari ignores HTMLMediaElement.volume writes (volume is read-only).
export const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ pretends to be MacIntel but exposes touch points
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
};
